<div class="container-fluid h-100" *ngIf="features.hasProfiles">
    <!-- Logo Image -->
    <div class="row brand-container">
        <div class="col-md-12 pt-4">
            <img class="brand-logo" src="assets/images/logo.png">
        </div>
    </div>

    <div class="row profiles-container">
        <div class="col-md-12">
            <h1 class="text-center">{{'gen_switch_profile' | translate}}</h1>

            <!-- Existing Profiles -->
            <div class="profile-container" *ngFor="let profile of profiles">
                <img class="profile-avatar" [src]="'assets/images/avatars/avatar' + profile.avatar + '.png'"
                    (click)="selectProfile(profile)" />
                <p [ngClass]="{'clr-theme': currentProfile?.id == profile.id}">{{profile.displayName}}</p>
                <p>
                    <i class="cursor-po-c fa fa-user-edit px-3" (click)="editProfile(profile)"
                        *ngIf="(currentProfile && currentProfile?.type == 0) || currentProfile?.id == profile.id"></i>

                    <i class="cursor-po-c fa fa-trash px-3" (click)="deleteProfile(profile)"
                        *ngIf="profile.type != 0 && currentProfile?.type == 0"></i>
                    <i class="opc-hide fa fa-user-plus"></i>
                </p>
            </div>

            <!-- New Profile -->
            <div class="profile-container" (click)="addProfile()" *ngIf="profiles && profiles.length < 5">
                <img class="profile-avatar" src="assets/images/addProfile.png" />
                <p>{{'gen_create_profile' | translate}}</p>
                <p class="opc-hide">
                    <i class="fa fa-user-plus"></i>
                </p>
            </div>
        </div>
    </div>
</div>